import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import {
  ApplicationBillRecipient,
  ApplicationData,
  ApplicationProductI,
  OptionI,
  ValidationSet
} from '../../../../../types/interface';
import StandardSelect from 'base/StandardSelect/StandardSelect';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import {
  capitalizeFirstLetter,
  formatDateOnly,
  convertToCurrency,
  convertToLabelValue,
  isFieldEmptyAndInOverview
} from 'utils/helpers';
import { useAppDispatch } from '../../../../redux/HooksRedux';
import * as applicationPreviewAction from '../../../../redux/applicationPreview/applicationPreviewAction';
import { WITH_INCOME, WITHOUT_INCOME } from 'utils/enums/misc';
import StandardInput from 'base/StandardInput/StandardInput';
import { StandardImageUpload } from 'base/StandardImageUpload/StandardImageUpload';

export const HealthApplicationForm = ({
  data,
  basic_data
}: {
  data: ApplicationData;
  basic_data: typeof WITHOUT_INCOME | typeof WITH_INCOME;
}) => {
  const disableField = true;
  const showError = false;
  const dispatch = useAppDispatch();
  const [allHealthRequestOptions, setAllHealthRequestOptions] = useState<
    OptionI[]
  >([]);

  const HealthApplicationValidationSet: ValidationSet<ApplicationBillRecipient> =
    {
      bill_recipient_id: [],
      bill_recipient: [],
      bill_recipient_name: [],
      bill_recipient_sum: [],
      invoice_issuer: [],
      bill_recipients_type: [],
      bill_number: [],
      date_invoice: [],
      total_invoice: [],
      paid_date: [],
      option: [],
      restoration_svt_to_eur: [],
      social_security_provider_refund_date: [],
      restoration_insurance: [],
      other_funds_date: [],
      invoice_date: [],
      total_svt_net: [],
      total_svt_gross: [],
      product_sum_amount: [],
      refund_percentage: [],
      refunded_amount: [],
      cost_of_goods_sold: [],
      social_security_provider_refund: [],
      other_funds: [],
      invoice: [],
      payment_confirmation: [],
      products: [],
      created_at: [],
      updated_at: []
    };

  const getAllApplicationOptionWithProduct = async () => {
    const params: any = {
      page: 1,
      limit: 999,
      keyword: '',
      is_archived: false
    };
    try {
      const response = await dispatch(
        applicationPreviewAction.getApplicationTypeOptionAll(params)
      );
      if (response?.status === 200) {
        const requestOption = convertToLabelValue(
          response.data?.request_options,
          'name',
          'application_request_id'
        );
        setAllHealthRequestOptions(requestOption);
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllApplicationOptionWithProduct();
  }, []);

  console.log({ basic_data });

  return (
    <div id="application-health" className="mt-3">
      <div className="row">
        <div className="col-12 mb-3">
          <h1 className="text-center">
            {capitalizeFirstLetter(t('overview.general.text_2'))}
          </h1>
        </div>
      </div>
      <div className="px-5">
        <div className="col-12 col-lg-7"></div>
        {data?.bill_recipients?.map((item, index: number) => {
          return (
            <>
              <ConditionalRender condition={index > 0}>
                <div className="row py-3">
                  <hr />
                </div>
              </ConditionalRender>
              <div className="row">
                <h4 className="pb-2">
                  {t('general.common_text.text_28')} {index + 1}
                </h4>
              </div>
              <div className="row mb-2">
                <div className="col-3">
                  <div id="standard-select-application-2">
                    <StandardSelect
                      value={item.option ? Number(item.option) : null}
                      disabled={disableField}
                      onChange={() => {}}
                      name={'option'}
                      placeholder={t(
                        'overview.health_application.table_header.text_10'
                      )}
                      label={t(
                        'overview.health_application.table_header.text_10'
                      )}
                      className={isFieldEmptyAndInOverview(true, !!item.option)}
                      options={allHealthRequestOptions}
                      showError={showError}
                      id=""
                      validations={HealthApplicationValidationSet.option}
                      formClassName=""
                    />
                  </div>
                </div>
                <div className="col-6"></div>
              </div>

              <div className="row">
                <div className="row">
                  <div className="col-10">
                    <div className="row py-2">
                      <div className="col-12 col-lg-6 col-md-6">
                        <StandardInput
                          value={item.bill_recipient_name}
                          disabled={disableField}
                          onChange={() => {}}
                          placeholder={t(
                            'overview.health_application.table_header.text_1'
                          )}
                          label={t(
                            'overview.health_application.table_header.text_1'
                          )}
                          showError={showError}
                          type=""
                          validations={
                            HealthApplicationValidationSet.bill_recipient_name
                          }
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.bill_recipient_name
                          )}
                        />
                      </div>
                      <div
                        className="col-12 col-lg-6 col-md-6"
                        id="application-input-1"
                      >
                        <StandardInput
                          type="text"
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.invoice_issuer
                          )}
                          placeholder={t(
                            'overview.health_application.table_header.text_2'
                          )}
                          label={t(
                            'overview.health_application.table_header.text_2'
                          )}
                          value={item.invoice_issuer}
                          disabled={disableField}
                          showError={showError}
                          onChange={() => {}}
                          validations={
                            HealthApplicationValidationSet.invoice_issuer
                          }
                        />
                      </div>
                    </div>
                    <div className="row py-2">
                      <div className="col-12 col-lg-3" id="application-input-2">
                        <StandardInput
                          type="text"
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.bill_number
                          )}
                          disabled={disableField}
                          placeholder={t(
                            'overview.health_application.table_header.text_3'
                          )}
                          label={t(
                            'overview.health_application.table_header.text_3'
                          )}
                          value={item.bill_number}
                          onChange={() => {}}
                          showError={showError}
                          validations={
                            HealthApplicationValidationSet.bill_number
                          }
                        />
                      </div>
                      <div
                        className="col-12 col-lg-3 col-md-6"
                        id="application-input-2"
                      >
                        <StandardInput
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.total_invoice
                          )}
                          disabled={disableField}
                          placeholder={t(
                            'overview.health_application.table_header.text_4'
                          )}
                          label={t(
                            'overview.health_application.table_header.text_4'
                          )}
                          onChange={() => {}}
                          showError={showError}
                          value={convertToCurrency(item.total_invoice)}
                          type=""
                          validations={
                            HealthApplicationValidationSet.total_invoice
                          }
                        />
                      </div>
                      <div
                        className="col-12 col-lg-3 col-md-6"
                        id="application-input-3"
                      >
                        <StandardInput
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.date_invoice
                          )}
                          disabled={disableField}
                          placeholder="Date invoice"
                          label={t(
                            'overview.health_application.table_header.text_5'
                          )}
                          value={formatDateOnly(item.date_invoice)}
                          onChange={() => {}}
                          showError={showError}
                          type=""
                          validations={
                            HealthApplicationValidationSet.date_invoice
                          }
                        />
                      </div>
                      <div
                        className="col-12 col-lg-3 col-md-6  mt-1 align-content-around"
                        id=""
                      >
                        <StandardImageUpload
                          value={item.invoice}
                          disabled={!disableField}
                          imageText={t('application.general.text_5')}
                          showError={showError}
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.invoice
                          )}
                        />
                      </div>
                    </div>
                    <div className="row py-2">
                      <div className="col-3"></div>
                      <div
                        className="col-12 col-lg-3 col-md-6"
                        id="application-input-2"
                      ></div>
                      <div
                        className="col-12 col-lg-3 col-md-6"
                        id="application-input-3"
                      >
                        <StandardInput
                          label={t('application.input.input_4')}
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.paid_date
                          )}
                          disabled={disableField}
                          placeholder="Paid date"
                          value={formatDateOnly(item.paid_date)}
                          onChange={() => {}}
                          showError={showError}
                          type=""
                          validations={HealthApplicationValidationSet.paid_date}
                        />
                      </div>
                      <div
                        className="col-12 col-lg-3 col-md-6 mt-1 align-content-around"
                        id=""
                      >
                        <StandardImageUpload
                          value={item.payment_confirmation}
                          disabled={!disableField}
                          imageText={t('application.general.text_27')}
                          showError={showError}
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.payment_confirmation
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-10">
                    <div className="row py-2">
                      <div className="col-12 col-lg-3 col-md-3 "></div>
                      <div
                        className="col-12 col-lg-3 col-md-3 "
                        id="application-input-4"
                      >
                        <StandardInput
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.restoration_svt_to_eur
                          )} form-control-icon d-flex flex-column justify-content-between h-100`}
                          disabled={disableField}
                          placeholder={t('application.input.input_5')}
                          label={t('application.input.input_5')}
                          value={convertToCurrency(item.restoration_svt_to_eur)}
                          showError={showError}
                          onChange={() => {}}
                          type=""
                          validations={
                            HealthApplicationValidationSet.restoration_svt_to_eur
                          }
                        />
                      </div>
                      <div
                        className="col-12 col-lg-3 col-md-3"
                        id="application-input-6"
                      >
                        <StandardInput
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.social_security_provider_refund_date
                          )} form-control-icon d-flex flex-column justify-content-between h-100`}
                          placeholder="Date proof"
                          value={formatDateOnly(
                            item.social_security_provider_refund_date
                          )}
                          label={t('application.input.input_16')}
                          disabled={disableField}
                          onChange={() => {}}
                          showError={showError}
                          type=""
                          validations={
                            HealthApplicationValidationSet.social_security_provider_refund_date
                          }
                        />
                      </div>
                      <div
                        className="col-12 col-lg-3 col-md-6 mt-1 align-content-around"
                        id=""
                      >
                        <StandardImageUpload
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.social_security_provider_refund
                          )}
                          value={item.social_security_provider_refund}
                          disabled={!disableField}
                          imageText={t('application.general.text_3')}
                          showError={showError}
                        />
                      </div>
                    </div>
                    <div className="row py-2 align-content-between">
                      <div
                        className="col-12 col-lg-3 col-md-6"
                        id="application-input-2"
                      ></div>
                      <div
                        className="col-12 col-lg-3 col-md-3"
                        id="application-input-4"
                      >
                        <StandardInput
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.restoration_insurance
                          )} form-control-icon d-flex flex-column justify-content-between h-100`}
                          placeholder={t('application.input.input_6')}
                          label={t('application.input.input_6')}
                          value={convertToCurrency(item.restoration_insurance!)}
                          disabled={disableField}
                          showError={showError}
                          onChange={() => {}}
                          type=""
                          validations={
                            HealthApplicationValidationSet.restoration_insurance
                          }
                        />
                      </div>

                      <div
                        className="col-12 col-lg-3 col-md-3 align-content-end"
                        id="application-input-6"
                      >
                        <StandardInput
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.other_funds_date
                          )} form-control-icon d-flex flex-column justify-content-between h-100`}
                          placeholder="Date Proof "
                          label={t('application.input.input_17')}
                          value={formatDateOnly(item.other_funds_date!)}
                          onChange={() => {}}
                          disabled={disableField}
                          showError={showError}
                          type=""
                          validations={
                            HealthApplicationValidationSet.other_funds_date
                          }
                        />
                      </div>

                      <div
                        className="col-12 col-lg-3 col-md-6 mt-1 align-content-around"
                        id=""
                      >
                        <StandardImageUpload
                          value={item.other_funds!}
                          disabled={!disableField}
                          imageText={t('application.general.text_4')}
                          showError={showError}
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.other_funds
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-10">
                  <div className="row py-2" key={index}>
                    {item?.products?.map((product: ApplicationProductI) => {
                      return (
                        <>
                          <div className="col-3">
                            <StandardInput
                              value={product.product_name}
                              placeholder={t(
                                'application.placeholder.product_option'
                              )}
                              label={t(
                                'application.placeholder.product_option'
                              )}
                              className={
                                'd-flex flex-column justify-content-between h-100'
                              }
                              showError={showError}
                              onChange={() => {}}
                              disabled={disableField}
                              type=""
                              validations={[]}
                            />
                          </div>

                          <div
                            className="col-12 col-lg-3 col-md-6"
                            id="application-input-9"
                          >
                            <StandardInput
                              className="form-control-icon d-flex flex-column justify-content-between h-100"
                              placeholder={t('application.input.input_12')}
                              label={t('application.input.input_12')}
                              value={convertToCurrency(
                                product.product_amount_net
                              )}
                              showError={showError}
                              onChange={() => {}}
                              disabled={disableField}
                              type=""
                              validations={[]}
                            />
                          </div>

                          <div
                            className="col-12 col-lg-3 col-md-6"
                            id="application-input-2"
                          >
                            <StandardInput
                              type="text"
                              className="form-control-icon d-flex flex-column justify-content-between h-100"
                              placeholder={t('application.input.input_11')}
                              disabled={disableField}
                              label={t('application.input.input_11')}
                              value={product.service_name_on_invoice}
                              onChange={() => {}}
                              showError={showError}
                              validations={[]}
                            />
                          </div>

                          <div
                            className="col-12 col-lg-3 col-md-6"
                            id="application-input-2"
                          >
                            <StandardInput
                              type="text"
                              className="form-control-icon d-flex flex-column justify-content-between h-100"
                              placeholder={t('application.input.input_3')}
                              label={t('application.input.input_3')}
                              onChange={() => {}}
                              value={
                                product.is_custom_refundable
                                  ? t('product_form.placeholder.text_7')
                                  : product.is_refundable
                                  ? t('product_form.placeholder.text_3')
                                  : t('product_form.placeholder.text_12')
                              }
                              showError={false}
                              disabled={true}
                              validations={[]}
                            />
                          </div>
                        </>
                      );
                    })}
                  </div>
                  <div className="col-10 pt-3">
                    <div className="col-12 d-flex">
                      <div className="col-6">
                        {t('application.general.text_13')}
                      </div>
                      <StandardInput
                        type="text"
                        className="col-6"
                        onChange={() => {}}
                        showError={false}
                        value={convertToCurrency(item?.bill_recipient_sum)}
                        disabled
                        label=""
                        placeholder=""
                        validations={
                          HealthApplicationValidationSet.bill_recipient_sum
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};
